import * as React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../reducers/reducers';
import Col from 'antd/lib/grid/col';
import Row from 'antd/lib/grid/row';
import { selectReleaseVersion } from '../../selectors/selectors';
import { OverviewSection, Statistic, StatisticType, StatisticWithAssociatedInfo } from '../../types';
import { statisticsForOverviewSection } from '../../helpers';
import { ReleaseOverviewStatCard } from '../StatCard';
import { GRID_GAP, GRID_CARD_MIN_WIDTH, GRID_MIN_WIDTH } from '../../constants';

export const LOWER_AUTOMATIONS_COUNT_THRESHOLD = 5;
export const LOWER_AUTOMATIONS_TIME_SAVED_THRESHOLD = 4 * 3_600;

interface HighlightsSectionProps {
    appId: string;
    releaseId: string;
    isLoadingReleaseStatsHistory: boolean;
    releaseStatsByTypes: Partial<Record<StatisticType, StatisticWithAssociatedInfo[]>>;
    currentReleaseStats: Statistic[];
}

const HighlightsSection: React.FC<HighlightsSectionProps> = (props: HighlightsSectionProps) => {
    const { releaseId, isLoadingReleaseStatsHistory, releaseStatsByTypes, currentReleaseStats } = props;

    const currentReleaseVersion = useSelector((state: RootState) => selectReleaseVersion(state, releaseId));

    const stats =
        currentReleaseStats?.filter((stat) => {
            return statisticsForOverviewSection(OverviewSection.Highlights).includes(stat.type);
        }) ?? [];

    return (
        <div>
            <Row>
                <Col span={20}>
                    <div
                        style={{
                            display: 'grid',
                            gap: GRID_GAP,
                            gridTemplateColumns: `repeat(auto-fill, minmax(${GRID_CARD_MIN_WIDTH}px, 1fr))`,
                            minWidth: GRID_MIN_WIDTH,
                            alignItems: 'start',
                        }}
                    >
                        {stats.map((stat) => {
                            const sampleStats = releaseStatsByTypes[stat.type];

                            return (
                                <ReleaseOverviewStatCard
                                    key={stat.type}
                                    type={stat.type}
                                    change={stat.change}
                                    isLoadingStats={isLoadingReleaseStatsHistory}
                                    changeStatus={stat.changeStatus}
                                    value={stat.value}
                                    unit={stat.unit}
                                    highlightedVersion={currentReleaseVersion}
                                    sampleStats={sampleStats}
                                    average={stat.average}
                                />
                            );
                        })}
                    </div>
                </Col>
            </Row>
        </div>
    );
};

export default HighlightsSection;
